mutation swapMphToTokenPermitted($input: SwapMphToTokenPermittedInput!, $tx_id: String) {
  swapMphToTokenPermitted(input: $input, tx_id: $tx_id)
}
